export class AppError {
    private _current = $state(false)

    get current() {
        return this._current
    }

    occured() {
        this._current = true
    }
}